import {
    Typography,
    Box
} from '@mui/material';
import { FileManager } from './FileManager';
import { JobSubmission } from './JobSubmission';
import JobStatusTable from './JobStatusTable';

function HomePage({ mode, fileOperations, jobParameters, user, callApi }) {
    return (
        <>
            <Box component="hr" sx={{
                border: 'none',
                borderTop: '1px solid #ccc',
                margin: '1em 0'
            }} />

            <Box sx={{
                display: 'flex',
                gap: '2em',
                '& > *': {
                    flex: '0 0 calc(50% - 1em)',  // Precise 50% calculation, accounting for gap
                    minWidth: 0,  // Allow flex items to shrink below their content size
                    overflow: 'hidden'  // Prevent content from overflowing
                }
            }}>
                <FileManager
                    mode={mode}
                    {...fileOperations}
                />

                <JobSubmission
                    mode={mode}
                    {...jobParameters}
                    submitJob={() => jobParameters.submitJob((params) => callApi({ user, ...params }))}
                />
            </Box>

            <Box
                sx={{
                    marginTop: '2em',
                    padding: '1em',
                    border: '1px solid #ccc',
                    borderRadius: '15px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    backgroundColor: mode === 'light' ? '#f9f9f9' : '#424242',
                    color: mode === 'light' ? '#000' : '#fff'
                }}
            >
                <Typography variant="h2" sx={{ fontSize: '1.5rem' }}>
                    Job Status
                </Typography>
                <JobStatusTable mode={mode} />
            </Box>
        </>
    );
}

export default HomePage;
